import { render, staticRenderFns } from "./DialogCurvasSegmentos.vue?vue&type=template&id=290b1af4"
import script from "./DialogCurvasSegmentos.vue?vue&type=script&lang=js"
export * from "./DialogCurvasSegmentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports